// extracted by mini-css-extract-plugin
module.exports = {"fromSide":"styles_fromSide__JW1gE","dsModalOut":"styles_dsModalOut__juP5n","dsModalIn":"styles_dsModalIn__Jv3Cs"};